import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupedAttributesListComponent } from 'src/app/shared/components/grouped-attributes-list/grouped-attributes-list.component';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';

@NgModule({
    declarations: [GroupedAttributesListComponent],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        PipesModule,
    ],
    exports: [GroupedAttributesListComponent]
})
export class GroupedAttributesListModule {
}
